module.exports = __webpack_public_path__ + "static/media/logo_AMAP.752320a9.png";